import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntercom = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 11,
			r: 11,
			fill: "#0D26BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.95703 5.5C6.85246 5.5 5.95703 6.39543 5.95703 7.5V13.5833C5.95703 14.6879 6.85246 15.5833 7.95703 15.5833H14.0404C14.1154 15.5833 14.1895 15.5792 14.2624 15.5712L16.0404 17.1875V14.4375L15.8308 14.4756C15.9649 14.207 16.0404 13.904 16.0404 13.5833V7.5C16.0404 6.39543 15.1449 5.5 14.0404 5.5H7.95703Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2087 12.832C13.3572 13.5941 12.2329 14.0574 11.0003 14.0574C9.76776 14.0574 8.64341 13.5941 7.79199 12.832",
			stroke: "#0D26BB"
		})
	]
});
export default SvgIntercom;
